// @flow

/**
 * Message Item Component
 * Renders individual chat messages (user or agent)
 */

import React from 'react';
import Bubble from './Bubble';
import UserMessageBody from './UserMessageBody';
import AgentMessageBody from './AgentMessageBody';

const MessageItem = ({ message, activeStreamMessageId }) => {
  const isActive = activeStreamMessageId && message.id === activeStreamMessageId;

  return (
    <Bubble $role={message.role}>
      {message.role === 'user' ? (
        <UserMessageBody text={message.text} />
      ) : (
        <AgentMessageBody 
          message={message} 
          isActive={isActive}
          activeStreamMessageId={activeStreamMessageId}
        />
      )}
    </Bubble>
  );
};

export default MessageItem;
